import AdminCrud from "@/pages/admin/components/AdminCrud";
import type { CrudField } from "@/pages/admin/components/AdminCrud";

const fields: CrudField[] = [
  { key: "question", label: "Question", required: true },
  { key: "answer", label: "Réponse", type: "textarea", required: true },
];

export default function AdminFaq() {
  return (
    <AdminCrud
      title="FAQ des dons"
      description="Les questions fréquentes affichées sur la page « Faire un don »."
      addLabel="Ajouter une question"
      table="faq_items"
      fields={fields}
      listTitleKey="question"
    />
  );
}